export default __webpack_public_path__ + "static/media/contentCopy.e70dcd67.svg";